'use client';
import React, { useCallback, useContext, useEffect } from 'react';
import { Button, LinearProgress, Text } from '@rneui/themed';
import { getManagePurchasesData, useChannelQuery, } from '@annunciate/query';
import { useUserUUID } from '@annunciate/core';
import { Oidc } from '../context';
export const PurchaseManage = () => {
    const { data: channel, isLoading } = useChannelQuery();
    const uuid = useUserUUID();
    const ctx = useContext(Oidc);
    const redirectUri = typeof window === 'undefined'
        ? undefined
        : window.location.href;
    const manage = channel && channel?.channel?.settings?.account?.managePurchases;
    const onManagePurchases = useCallback(async (link) => {
        let url = undefined;
        try {
            const data = await getManagePurchasesData();
            url = data.url;
        }
        catch (err) {
        }
        const linkToOpen = url || link;
        if (!linkToOpen)
            return;
        window.location.replace(linkToOpen);
    }, []);
    useEffect(() => {
        if (!isLoading && uuid) {
            onManagePurchases(manage.link);
        }
    }, [isLoading, uuid, onManagePurchases, manage]);
    if (!manage || (!uuid && manage.isAuthRequired)) {
        return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
            React.createElement(Text, null, "You must first log in to manage your purchases."),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Button, { onPress: () => ctx.signIn(redirectUri), title: "Sign In" })));
    }
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, "Preparing to manage your purchases."),
        React.createElement(LinearProgress, { style: { marginVertical: 10 } })));
};
//# sourceMappingURL=PurchaseManage.js.map